/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockHour4 = createReactComponent("clock-hour-4", "IconClockHour4", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 12l3 2", key: "svg-1" }],
  ["path", { d: "M12 7v5", key: "svg-2" }]
]);

export { IconClockHour4 as default };
//# sourceMappingURL=IconClockHour4.js.map
